import styles from './ProposalHeader.module.css';

function ProposalHeader({ productName, productImage, category, subtitle, productUrl, myPoolUrl, brandLogo }) {
  return (
    <div className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.info}>
          {category && <p className={styles.category}>{category}</p>}
          <h1 className={styles.title}>{productName}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <a className={styles.productLink} href={productUrl || '#'} target={productUrl ? '_blank' : undefined} rel="noreferrer">
            View Product Details
          </a>
          {myPoolUrl && (
            <a className={styles.poolLink} href={myPoolUrl} target="_blank" rel="noreferrer">
              View on My Pool
            </a>
          )}
        </div>
        <div className={styles.imageWrap}>
          {productImage && (
            <img src={productImage} alt={productName} className={styles.productImage} />
          )}
        </div>
        <div className={styles.brandWrap}>
          {brandLogo && (
            <img src={brandLogo} alt="" className={styles.brandLogo} />
          )}
        </div>
      </div>
    </div>
  );
}

export default ProposalHeader;
